
import { defineComponent } from 'vue';
import ReportOptionComponent from "@/components/reportsComponents/ReportOption.vue";
import ExternalTransactions from '@/views/ExternalTransactions.vue';
import Withdrawals from '@/views/Withdrawals.vue';

export default defineComponent({
    name: "ReportsPage",

    components: { ReportOptionComponent, ExternalTransactions, Withdrawals },

    data() {
        return {
            statusComponent: "Menu",
            options: [
                {
                    title: "تراکنش ها",
                    path: "transactions",
                    icon: 'mdi-swap-horizontal'
                },
                {
                    title: "تسویه حساب ها",
                    path: "withdrawals",
                    icon: 'mdi-file-document-outline'
                },
            ]
        }
    },

    methods: {
        changeStatusComponent(status: string): void {
            this.$router.push({
                query: { ...this.$route.query, path: status },
            });

            switch (status) {
                case "logs":
                    this.statusComponent = "logs";
                    break;
                case "settings":
                    this.statusComponent = "settings";
                    break;
                case "gateways":
                    this.statusComponent = "gateways";
                    break;
                case "transactions":
                    this.statusComponent = "transactions";
                    break;
                case "withdrawals":
                    this.statusComponent = "withdrawals";
                    break;

                default:
                    this.statusComponent = "Menu";
                    // Optionally clear the query parameter or set to default
                    this.$router.push({
                        query: { ...this.$route.query, path: undefined },
                    });
                    break;
            }
        },

        resetStatusComponent(): void {
            this.statusComponent = "Menu";
        },

        selectedOption(option: { title: string, path: string, icon: string }): void {
            this.changeStatusComponent(option.path)
        }
    },

    // Watch for route changes to update statusComponent
    watch: {
        "$route.query.path"(newPath: string) {
            if (newPath && newPath !== this.statusComponent) {
                this.changeStatusComponent(newPath);
            }

            if(!newPath) {
                this.resetStatusComponent();
            }
        },
    },
})
